import { formatDate } from 'v3/utils/controlTowerDate';
const id = (v) => Number.isSafeInteger(v) && v > 0;
const text = (v) => v === null || typeof v === 'string';
const date = (v) => v === null || (typeof v === 'string' && formatDate(v) !== 'Não informado');
const point = (v) => v === null || (id(v?.id) && text(v.city) && text(v.province));
const codes = ['PICKUP', 'TRANSIT', 'DESTINATION'];
const sources = ['PICKUP_EVENTS', 'FINAL_ARRIVAL', 'TRAVEL_STATUS', 'FINISHED_EVENT', 'UNKNOWN'];
export function validateProgress(data, items) {
  const fail = () => {
    throw new Error('Resposta inválida do progresso das viagens.');
  };
  if (
    data?.version !== 1 ||
    data.timezone !== 'America/Sao_Paulo' ||
    !data.asOf ||
    !date(data.asOf) ||
    !Array.isArray(data.data) ||
    data.data.length !== items.length
  )
    fail();
  const requested = new Map(items.map((item) => [item.travelId, item]));
  const found = new Set();
  for (const row of data.data) {
    const item = requested.get(row?.travelId);
    if (
      !item ||
      found.has(row.travelId) ||
      row.loadId !== item.loadId ||
      !text(row.statusCode) ||
      ![null, 'ATTENDED', 'IN_TRANSIT', 'AT_DESTINATION'].includes(row.group) ||
      !Array.isArray(row.wagonIds) ||
      !row.wagonIds.every(id) ||
      new Set(row.wagonIds).size !== row.wagonIds.length ||
      !Array.isArray(row.stages) ||
      row.stages.length !== 3 ||
      !row.stages.every(
        (s, i) =>
          s?.code === codes[i] &&
          ['COMPLETED', 'CURRENT', 'PENDING', 'UNKNOWN'].includes(s.state) &&
          sources.includes(s.source) &&
          date(s.at),
      ) ||
      !point(row.origin) ||
      !point(row.destination) ||
      !date(row.scheduledDeliveryAt) ||
      !date(row.deliveryCompletedAt) ||
      !row.responsible ||
      row.responsible.assetType !== 'vehicle' ||
      row.responsible.assetId !== (item.vehicle?.id ?? null) ||
      !(row.responsible.assetId === null || id(row.responsible.assetId)) ||
      !['plate', 'name', 'phone'].every((k) => text(row.responsible[k])) ||
      !(row.responsible.userId === null || id(row.responsible.userId)) ||
      !row.costCenter ||
      !(row.costCenter.id === null || id(row.costCenter.id)) ||
      !text(row.costCenter.name) ||
      ![null, 'TRAVEL', 'LOAD', 'VEHICLE_SETTINGS'].includes(row.costCenter.source) ||
      !['CURRENT', 'EXPIRED', 'UNVERIFIED', 'MISSING'].includes(row.position?.state) ||
      !['CURRENT', 'UNAVAILABLE'].includes(row.arrival?.state) ||
      !['estimatedAt', 'calculatedAt', 'validUntil'].every((k) => date(row.arrival[k])) ||
      !(
        row.arrival.remainingDistanceMeters === null ||
        (typeof row.arrival.remainingDistanceMeters === 'number' &&
          Number.isFinite(row.arrival.remainingDistanceMeters) &&
          row.arrival.remainingDistanceMeters >= 0)
      ) ||
      !Array.isArray(row.issues) ||
      !row.issues.every((i) => typeof i === 'string')
    )
      fail();
    found.add(row.travelId);
    const p = row.position.observation;
    if (row.position.state === 'MISSING') {
      if (p !== null) fail();
    } else if (
      !p ||
      p.travelId !== row.travelId ||
      p.compositionVerified !== true ||
      !['TRAVEL_LOCATION', 'TRAVEL_SNAPSHOT', 'WAGON_TELEMETRY'].includes(p.source) ||
      !(p.assetType === 'VEHICLE'
        ? p.assetId === row.responsible.assetId
        : p.assetType === 'WAGON' && row.wagonIds.includes(p.assetId)) ||
      ![p.lat, p.lng].every((v) => typeof v === 'number' && Number.isFinite(v)) ||
      Math.abs(p.lat) > 90 ||
      Math.abs(p.lng) > 180 ||
      !p.capturedAt ||
      !date(p.capturedAt) ||
      Date.parse(p.capturedAt) > Date.parse(data.asOf) ||
      !date(p.validUntil) ||
      !['city', 'province', 'information'].every((k) => text(p[k])) ||
      !['SOURCE_VALID', 'POST_UNLOAD_24H', 'EXPIRED', 'UNKNOWN_VALIDITY'].includes(p.validity) ||
      (row.position.state === 'CURRENT' &&
        (!p.validUntil ||
          Date.parse(p.validUntil) < Date.parse(p.capturedAt) ||
          Date.parse(p.validUntil) < Date.parse(data.asOf) ||
          !['SOURCE_VALID', 'POST_UNLOAD_24H'].includes(p.validity)))
    )
      fail();
    const a = row.arrival;
    if (
      a.state === 'CURRENT' &&
      (!a.estimatedAt ||
        !a.calculatedAt ||
        !a.validUntil ||
        a.remainingDistanceMeters === null ||
        row.group !== 'IN_TRANSIT' ||
        Date.parse(a.calculatedAt) > Date.parse(data.asOf) ||
        Date.parse(a.estimatedAt) < Date.parse(data.asOf) ||
        a.validUntil !== p.validUntil ||
        row.position.state !== 'CURRENT' ||
        p.validity !== 'SOURCE_VALID')
    )
      fail();
    if (
      a.state === 'UNAVAILABLE' &&
      [a.estimatedAt, a.calculatedAt, a.validUntil, a.remainingDistanceMeters].some(
        (v) => v !== null,
      )
    )
      fail();
  }
  return data;
}
export function currentProgress(row, now = Date.now()) {
  const p = row.position.observation;
  const state =
    row.position.state === 'CURRENT' &&
    (Date.parse(p.validUntil) < now || Date.parse(p.capturedAt) > now)
      ? 'EXPIRED'
      : row.position.state;
  const arrivalCurrent =
    row.arrival.state === 'CURRENT' &&
    state === 'CURRENT' &&
    Date.parse(row.arrival.validUntil) >= now &&
    Date.parse(row.arrival.estimatedAt) >= now;
  return { positionState: state, arrivalCurrent };
}
